import { useEffect, useState } from "react";
import firebase from "firebase/app";
import { PollResponse } from "../interfaces/Polls";

const useOpenEndedResponses = (firebaseApp: firebase.app.App | null, pageId: string) => {
	const [openEndedResponses, setOpenEndedResponses] = useState<PollResponse[]>([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!firebaseApp || !pageId) {
			setLoading(false);
			return;
		}

		setLoading(true);

		const db = firebaseApp.firestore();
		const resultsRef = db
			.collection("polls")
			.doc(pageId)
			.collection("open-ended");

		const unsubscribe = resultsRef.onSnapshot(snapshot => {
			const responses: PollResponse[] = [];
			snapshot.forEach(doc => {
				responses.push(doc.data() as PollResponse);
			});
			setOpenEndedResponses(responses);
			setLoading(false);
		});

		return () => unsubscribe();
	}, [firebaseApp, pageId]);

	return { openEndedResponses, loading };
};

export default useOpenEndedResponses;
